module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "form",
    attrs: {
      "rules": _vm.rules,
      "model": _vm.currForm,
      "label-width": "80px",
      "label-position": "left"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "名称",
      "prop": "name"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "disabled": !_vm.edit,
      "placeholder": "最多20个字"
    },
    model: {
      value: (_vm.currForm.name),
      callback: function($$v) {
        _vm.$set(_vm.currForm, "name", $$v)
      },
      expression: "currForm.name"
    }
  }), _vm._v(" "), (_vm.currForm.id) ? _c('span', [_vm._v("当前装配人数：" + _vm._s(_vm.currForm.countUsed))]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "动态贴纸详情",
      "prop": "topUrl"
    }
  }, [(_vm.edit) ? _c('UploadDragImg', {
    attrs: {
      "disabled": _vm.edit,
      "tips": "（尺寸：750*128，jpg、png、gif）",
      "imgUrl": _vm.currForm.topUrl
    },
    on: {
      "update:imgUrl": function($event) {
        return _vm.$set(_vm.currForm, "topUrl", $event)
      },
      "update:img-url": function($event) {
        return _vm.$set(_vm.currForm, "topUrl", $event)
      }
    }
  }) : _c('img', {
    attrs: {
      "width": "360",
      "height": "180",
      "src": _vm.currForm.topUrl,
      "alt": ""
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "动态贴纸外部",
      "prop": "bottomUrl"
    }
  }, [(_vm.edit) ? _c('UploadDragImg', {
    attrs: {
      "disabled": _vm.edit,
      "tips": "（尺寸：336*72，jpg、png、gif）",
      "imgUrl": _vm.currForm.bottomUrl
    },
    on: {
      "update:imgUrl": function($event) {
        return _vm.$set(_vm.currForm, "bottomUrl", $event)
      },
      "update:img-url": function($event) {
        return _vm.$set(_vm.currForm, "bottomUrl", $event)
      }
    }
  }) : _c('img', {
    attrs: {
      "width": "360",
      "height": "180",
      "src": _vm.currForm.bottomUrl,
      "alt": ""
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "动态贴纸选择",
      "prop": "listUrl"
    }
  }, [(_vm.edit) ? _c('UploadDragImg', {
    attrs: {
      "disabled": _vm.edit,
      "tips": "（尺寸：330*128，jpg、png、gif）",
      "imgUrl": _vm.currForm.listUrl
    },
    on: {
      "update:imgUrl": function($event) {
        return _vm.$set(_vm.currForm, "listUrl", $event)
      },
      "update:img-url": function($event) {
        return _vm.$set(_vm.currForm, "listUrl", $event)
      }
    }
  }) : _c('img', {
    attrs: {
      "width": "360",
      "height": "180",
      "src": _vm.currForm.listUrl,
      "alt": ""
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "展示排序",
      "prop": "sort"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0,
      "disabled": !_vm.edit
    },
    model: {
      value: (_vm.currForm.sort),
      callback: function($$v) {
        _vm.$set(_vm.currForm, "sort", $$v)
      },
      expression: "currForm.sort"
    }
  }), _vm._v(" "), _c('div', [_vm._v("数字越大越靠前")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "拥有学生",
      "prop": "type"
    }
  }, [_c('SelectStudent', {
    ref: "SelectStudentRef",
    attrs: {
      "disabled": _vm.edit,
      "selectVal": _vm.currForm.useType,
      "privileges": _vm.currForm.privilegeRole
    },
    on: {
      "update:selectVal": function($event) {
        return _vm.$set(_vm.currForm, "useType", $event)
      },
      "update:select-val": function($event) {
        return _vm.$set(_vm.currForm, "useType", $event)
      }
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "角标图片"
    }
  }, [_c('SUpload', {
    attrs: {
      "accept": "image/*",
      "type": "drag",
      "size": 50,
      "disabled": !_vm.edit,
      "show-file-list": false
    },
    model: {
      value: (_vm.currForm.superscript),
      callback: function($$v) {
        _vm.$set(_vm.currForm, "superscript", $$v)
      },
      expression: "currForm.superscript"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tips"
  }, [_vm._v("尺寸建议40*40，最大50KB，优先SVG其次png")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c94f7db8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/OperationManage/UserAdminister/PersonalizedPart/Components/Sticker.vue
// module id = 1124
// module chunks = 0